import { createContext, useState } from "react";
import getWarehouseList from "../services/WhereToBuy/warehouse/getWarehouseList";
import toast from "react-hot-toast";

const MapsContext = createContext();

const MapsProvider = ({ children }) => {
  const [markersWhereBuy, setMarkersWhereBuy] = useState(null);
  const [centerWhereBuy, setCenterWhereBuy] = useState({
    lat: -31.417,
    lng: -64.183,
  });

  const uruguay = {
    id: 10000,
    coordenadas: "-34.83436, -56.20814",
    nombre: "CORRALON HOPRESA ",
    corralon_id: 1001,
    country_name: "Uruguay",
    pais_id: 598,
    localidad: "Montevideo, Uruguay",
    direccion: "Bvar. Batlle y Ordóñez 5840",
    telefono: "2359 2526",
    email: "ventas@hopresa.com.uy",
    lat: "-34.83436",
    long: "-56.20814",
    created_at: "2021-04-06 11:19:23",
    updated_at: "2021-04-06 11:19:23",
    deleted_at: null,
  };

  const getAllCorralones = async () => {
    try {
      const response = await getWarehouseList();
      return [
        ...response?.data?.data, uruguay
      ]
    } catch (error) {
      toast.error('Error al obtener corralones')
    }
  }

  const processWarehouseList = async () => {
    try {
      const response = await getWarehouseList();
      const pos = response.data.data.map(({ id, lat, long }) => {
        return {
          id,
          position: {
            lat: Number(lat),
            lng: Number(long),
          },
        };
      });
      setMarkersWhereBuy([
        ...pos,
        {
          id: 10000,
          position: {
            lat: -34.83436,
            lng: -56.20814,
          },
        },
      ]);
      return([...response?.data?.data, uruguay]);
    } catch (error) {
      toast.error('Error al obtener corralones');
    }
  };

  // TENSOLITE EN EL MUNDO

  const centerInTheWorld = { lat: -25, lng: -67.597907 };
  const centerInTheWorldSmall = {
    lat: -26.8,
    lng: -65.19,
  };
  const centerInTheWorldMedium = { lat: -10, lng: -30 };

  const markersInTheWorld = [
    {
      id: 1,
      oficina: "Tucumán",
      position: {
        lat: -26.7863297,
        lng: -65.2134109,
      },
    },
    {
      id: 2,
      oficina: "Cordoba",
      position: {
        lat: -31.6404425,
        lng: -63.9130746,
      },
    },
    {
      id: 3,
      oficina: "Paraguay",
      position: {
        lat: -25.2950404,
        lng: -57.5830311,
      },
    },
    {
      id: 4,
      oficina: "Uruguay",
      position: {
        lat: -34.83436,
        lng: -56.20814,
      },
    },
    {
      id: 5,
      oficina: "Miami",
      position: {
        lat: 25.6859558,
        lng: -80.3856187,
      },
    },
  ];

  const warehouseListInTheWorld = [
    {
      coordenadas: "-26.7863297, -63.9130746",
      direccion: "Ruta Nac. 9 km 1298",
      email: "comunicaciones@tensolite.com",
      id: 1,
      lat: "-26.7863297",
      localidad: "Los Pocitos, Tucumán",
      long: "-63.9130746",
      nombre: "ARGENINA - TUCUMÁN",
      telefono: "+54 381 437 2215",
    },

    {
      coordenadas: "-31.6404425, -63.9130746 ",
      direccion: "Ruta Nac. 9 km 666",
      email: "comunicaciones@tensolite.com",
      id: 2,
      lat: "-31.6404425",
      localidad: "Río Segundo, Córdoba",
      long: "-63.9130746 ",
      nombre: "ARGENINA - CORDOBA",
      telefono: "+54 3572 42 1343",
    },

    {
      coordenadas: "-25.2950404, -57.5830311",
      direccion: "Aviadores del Chaco 2581",
      email: "comunicaciones@tensolite.com",
      id: 3,
      lat: "-25.2950404",
      localidad: "Asuncion, Paraguay",
      long: "-57.5830311",
      nombre: "PARAGUAY - ASUNCION",
      telefono: "+54 381 437 2215",
    },

    {
      coordenadas: "-34.83436, -56.20814",
      direccion: "Bvar. Batlle y Ordóñez 5840",
      email: "ventas@hopresa.com.uy",
      id: 4,
      lat: "-34.83436",
      localidad: "Montevideo, Uruguay",
      long: "-56.20814",
      nombre: "URUGUAY - MONTEVIDEO",
      telefono: "2359 2526",
    },

    {
      coordenadas: "25.6859558, -80.3856187",
      direccion: "444 Brickell Ave. 81 SE 5th St",
      email: "comunicaciones@tensolite.com",
      id: 5,
      lat: "25.6859558",
      localidad: "Miami, United States",
      long: "-80.3856187",
      nombre: "UNITED STATES - MIAMI",
      telefono: "+1 305-273-0625",
    },
  ];

  return (
    <MapsContext.Provider
      value={{
        markersWhereBuy,
        centerWhereBuy,
        centerInTheWorld,
        centerInTheWorldMedium,
        centerInTheWorldSmall,
        markersInTheWorld,
        warehouseListInTheWorld,
        setCenterWhereBuy,
        processWarehouseList,
        getAllCorralones
      }}
    >
      {children}
    </MapsContext.Provider>
  );
};

export { MapsProvider };

export default MapsContext;
